import { createStore } from 'vuex'
import axios from 'axios'
export const store = createStore({
    state() {
        return {
            AR: null,
            CA: null,
            LU: null,
        //  ME: null,     // 2023.07.28 削除
            RS: null,
        //  MEST: null,   // 2023.07.28 削除
        //  TW: null,     // 2024.10.23 削除
            KN: null,
            SIDEBANNER: null
        }
    },
    mutations: {
        setCar(state,car) {
            state.AR = car[0];
            state.CA = car[1];
            state.LU = car[2];
        //  state.ME = car[3];      // 2023.07.28 削除
        //  state.RS = car[4];      // 2023.07.28 削除
        //  state.MEST = car[5];    // 2023.07.28 削除
        //  state.TW = car[6];      // 2023.07.28 削除
        //  state.KN = car[7];      // 2023.07.28 削除
            state.RS = car[3];      // 2023.07.28 変更
        //  state.TW = car[4];      // 2024.10.23 削除
            state.KN = car[4];      // 2024.10.23 変更
        },
        setSideBanner(state,car) {
            state.SIDEBANNER = car;
        },

    },
    actions: {
        async setCar(context) {
            const axiAR =  axios.get('./assets/json/AR.json');
            const axiCA =  axios.get('./assets/json/CA.json');
            const axiLU =  axios.get('./assets/json/LU.json');
        //  const axiME =  axios.get('./assets/json/ME-H.json');    // 2023.07.28 削除
            const axiRS =  axios.get('./assets/json/RS.json');
        //  const axiMEST =  axios.get('./assets/json/ME-M.json');  // 2023.07.28 削除
        //  const axiTW =  axios.get('./assets/json/TW.json');      // 2024.10.23 削除
            const axiKN =  axios.get('./assets/json/KN.json');

            const ar = await axiAR;
            const ca = await axiCA;
            const lu = await axiLU;
        //  const me = await axiME;         // 2023.07.28 削除
            const rs = await axiRS;
        //  const mest = await axiMEST;     // 2023.07.28 削除
        //  const tw = await axiTW;         // 2024.10.23 削除
            const kn = await axiKN;
        //  const all = [ar.data,ca.data,lu.data,me.data,rs.data,mest.data,tw.data,kn.data];  // 2023.07.28 削除
        //  const all = [ar.data,ca.data,lu.data,rs.data,tw.data,kn.data];  // 2023.07.28 更新
            const all = [ar.data,ca.data,lu.data,rs.data,kn.data];   // 2024.10.23 更新
        context.commit('setCar', all);  
        },
        async setSideBanner(context) {
            const getsidebanner =  axios.get('./assets/json/sidebanner.json');
            const sidebanner = await getsidebanner;
            context.commit('setSideBanner', sidebanner.data);  
        },
    },
})